import { Box, IconButton } from '@mui/material'
import type { SidebarCollapseButtonProps } from './types'
import { Icon } from '@/components/Icon'
import type { FC } from 'react'
import { styles } from './styles'

export const SidebarCollapseButton: FC<SidebarCollapseButtonProps> = (
  props
) => {
  const { collapse, setCollapse } = props

  return (
    <Box sx={styles.root}>
      <IconButton
        onClick={() => setCollapse((prev: boolean) => !prev)}
        className="iconButton"
      >
        <Box className={!collapse ? 'mainicon' : 'mainicon-collapse'}>
          <Icon section="general" size="20" name="collapse" />
        </Box>
        <Box className={!collapse ? 'swapicon' : 'swapicon-collapse'}>
          <Icon section="general" size="20" name="collapse" />
        </Box>
      </IconButton>
    </Box>
  )
}
